import { SM_DEVICE, PALETTE } from '../../../constants';
import { MediaQueryStyleSheet } from 'react-native-responsive';

const style = MediaQueryStyleSheet.create({
  mainWrapper: {
    flex: 1,
  },
  content: {
    paddingHorizontal: 40,
    paddingBottom: 40,
    display: 'inline-block',
  },
  inputFields: {
    flex: 1,
  },
  label: {
    paddingTop: 10,
  },
  username: {
    minHeight: 50,
  },
  email: {
    minHeight: 50,
  },
  submitButton: {
    marginTop: 30,
  },
  forgotPasswordPrompt: {
    flex: 1,
  },
  attemptCount: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 30,
  },
  errorTextColor: {
    color: 'red',
  },
  copyrightDisclaimer: {
    textAlign: 'center',
    fontSize: 8,
    color: PALETTE.loginPrimary,
    paddingBottom: 10,
  },
  labelStyle: {
    color: '#A3A4A7',

    letterSpacing: 0.35,
    fontSize: 15,
    marginBottom: 12,
  },
  formGroup: {
    marginBottom: 30,
  },
  formGroupErrorMargin: {
    marginBottom: 0,
  },
  'formGroupLastMargin': {
    marginBottom: 40,
  },
  formGroupErrorLastMargin: {
    marginBottom: 0,
  },
  input: {
    paddingVertical: 10,
    paddingRight: 32
  },
  userError: {
    marginTop: 5.75,
    marginBottom: 5.75,
    fontSize: 14
  },
  passwordError: {
    marginTop: 10,
    marginBottom: 11.5
  },
  questionMark: {
    position: 'absolute',
    top: '25%',
    right: 10
  },
  questionMarkPopover: {
    position: 'absolute',
    bottom: 28,
    left: -297,
    width: 344,
    zIndex: 1
  },
  questionMarkPopoverArrow: {
    right: 27
  },
  secondaryTextLogin: {
    color: PALETTE.primaryActive
  },
  padTop40:{
    paddingTop: 40
  }
}, {
  [SM_DEVICE]: {
    labelStyle: {
      fontSize: 13
    },
    formGroup: {
      marginBottom: 26,
    },
    'formGroupLastMargin': {
      marginBottom: 36,
    },
    userError: {
      fontSize: 14
    },
    passwordError: {
      fontSize: 11
    },
    questionMarkPopover: {
      position: 'absolute',
      bottom: 28,
      left: -249,
      width: 300,
    },
    questionMarkPopoverArrow: {
      right: 31
    }
  }
});

export default style;
